<!--
 * @Descripttion: 雷达图属性配置
 * @Author: zenghua.wang
 * @Date: 2021-10-11 14:53:25
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-11-16 10:24:17
-->
<template>
  <el-collapse
    v-model="collapse"
    accordion
  >
    <el-collapse-item
      name="1"
      :title="component.basic"
    >
      <config-base :data="data" />
    </el-collapse-item>

    <!-- 接口设置 -->
    <api-interface
      :data="data"
      :apis="main.apiTableList"
    >
      <template v-slot:extend>
        <echart-field
          :data="data"
          :max="true"
          :validate="['prop', 'type']"
        />
        <echart-filter :data="data" />
      </template>
    </api-interface>

    <el-collapse-item title="雷达图">
      <el-form-item label="绘制类型">
        <el-radio-group
          v-model="data.option.shape"
          size="mini"
        >
          <el-radio-button label="polygon">多边形</el-radio-button>
          <el-radio-button label="circle">圆形</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="字体大小">
        <el-input-number v-model="data.option.nameFontSize" />
      </el-form-item>

      <el-form-item label="字体颜色">
        <el-color-picker
          v-model="data.option.nameColor"
          :predefine="predefineColors"
        />
      </el-form-item>

      <el-form-item label="区域透明度">
        <el-slider
          v-model="data.option.areaOpacity"
          :max="1"
          :step="0.1"
        />
      </el-form-item>

      <el-form-item label="横坐标(%)">
        <el-slider
          v-model="data.option.centerX"
          :min="0"
          :max="100"
        />
      </el-form-item>

      <el-form-item label="纵坐标(%)">
        <el-slider
          v-model="data.option.centerY"
          :min="0"
          :max="100"
        />
      </el-form-item>

      <el-form-item label="半径(%)">
        <el-slider
          v-model="data.option.centerR"
          :min="0"
          :max="100"
        />
      </el-form-item>
    </el-collapse-item>

    <!-- echart公共 -->
    <echart-common :data="data" />
  </el-collapse>
</template>
<script>
import configBase from '@/dragComponents/config/common/base.vue'
import apiInterface from '@/dragComponents/config/api/index.vue'
import echartField from '@/dragComponents/config/common/field.vue'
import echartFilter from '@/dragComponents/config/common/filter.vue'

import echartCommon from './common.vue'

import {
  predefineColors,
  component,
  theme
} from '@/dragComponents/model/default.js'

export default {
  name: 'config-echart-radar',
  components: {
    configBase,
    echartCommon,
    echartField,
    echartFilter,
    apiInterface
  },
  inject: ['main', 'category'],
  props: ['data', 'collapse'],
  data() {
    return {
      theme: theme,
      predefineColors: predefineColors,
      component: component
    }
  },
  methods: {}
}
</script>
